import { render, staticRenderFns } from "./LanguageToggle.vue?vue&type=template&id=b7d0fd92&"
import script from "./LanguageToggle.vue?vue&type=script&lang=js&"
export * from "./LanguageToggle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports